import {EVENTS} from "./constants";
import Logger from "./logger";

import VerifyForm from "./forms/verifyform";
import OrderForm from "./forms/orderform";
import BalanceForm from "./forms/balanceform";

/**
 * Класс конструктор для инициализации компонента
 */
class ApiPlugin extends Logger {
	constructor() {
		super();

		this.EVENTS = EVENTS;

		this.verifyForm = new VerifyForm;
		this.orderForm = new OrderForm;
		this.balanceForm = new BalanceForm;

		this.setVerified(false);
		this.setPhone("");

		BX.addCustomEvent(EVENTS.VERIFY.ALREADY_VERIFIED, (params) => {
			if (!params.phone) {
				return;
			}

			this.logInfo("phone already verified " + params.phone);

			this.setVerifiedPhone(params.phone);
		});

		BX.addCustomEvent(EVENTS.VERIFY.NO_PHONE_VERIFY, () => {
			this.verifyForm.setSubmitAvailable();
		});

		BX.addCustomEvent(EVENTS.VERIFY.VERIFIED, (params) => {
			if (!params.phone) {
				return;
			}

			this.logInfo("verified " + params.phone);

			this.setVerifiedPhone(params.phone);
			this.verifyForm.setVerifiedPhone(params.phone);
		});

		BX.addCustomEvent(EVENTS.ORDER.OPEN, () => {
			if (this.isVerified()) {
				BX.onCustomEvent(EVENTS.BONUS_WRITE_OFF.RELOAD, [{
					phone: this.getPhone(),
					open: true
				}]);
			} else {
				BX.onCustomEvent(EVENTS.VERIFY.OPEN);
			}
		});
	}

	/**
	 * Фиксируем параметры компонента
	 * @param params
	 */
	initVerifyForm(params) {
		this.verifyForm.init(params);

		return this;
	}

	initOrder(params) {
		this.orderForm.init(params);

		return this;
	}

	initBalance(params) {
		this.balanceForm.init(params);

		return this;
	}

	setPhone(phone) {
		this.phone = phone;

		return this;
	}

	getPhone() {
		return this.phone;
	}

	setVerifiedPhone(phone) {
		this.setVerified();
		this.setPhone(phone);
	}

	setVerified(verified = true) {
		this.verified = verified;

		return this;
	}

	isVerified() {
		return this.verified;
	}
}

let Api;
Api = new ApiPlugin();
export {Api};
